import axios from 'axios'
import { apiBaseUrl } from '../config/runtime'

const API_BASE_URL = apiBaseUrl()

export const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

// Attachement automatique du token JWT
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Gestion des erreurs d'authentification
api.interceptors.response.use(
  response => response,
  error => {
    // Ne pas rediriger sur les échecs des endpoints d'authentification :
    // le formulaire de connexion / MFA gère lui-même ces erreurs (401).
    const url: string = error.config?.url ?? ''
    const isAuthEndpoint =
      url.includes('/auth/login') || url.includes('/auth/dev-sso') || url.includes('/auth/mfa')
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)
